import { SearchFacetResponse } from "../backend/responses";

export interface SearchFacet {
    type: string;
    id: number;
    name: string;
    count: number;
}

export const convertSearchFacetResponseList = (
    res: SearchFacetResponse[]
): SearchFacetResponse[] => {
    if (!res) return null;
    const facets = res.filter(f => !!f);
    return facets.map(f => convertSearchFacetResponse(f));
};

export const convertSearchFacetResponse = (
    res: SearchFacetResponse
): SearchFacet => {
    if (!res) return null;
    return {
        count: res.count,
        id: res.id,
        name: res.name,
        type: res.type,
    };
};
